import type { WarehouseHydraItem } from "@verbleif/lib/src/composables/Api/Type/Warehouse/warehouse.interface";
import type { CrudArgs } from "./composables/ContextVoter";
import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export type WarehouseEntityVote = Pick<WarehouseHydraItem, "isDefault"> & CrudArgs;

interface WarehouseVoterInterface extends Omit<ContextVoterInterface, "canRead" | "canDelete"> {
  canRead: (item?: CrudArgs) => boolean
  canDelete: (item: WarehouseEntityVote) => boolean
}

export class WarehouseVoter extends ContextVoter implements WarehouseVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationWarehouseCreateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationWarehouseCreate,
    });
  };

  public canRead = (item: CrudArgs = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }): boolean => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationWarehouseReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationWarehouseRead,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationWarehouseUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationWarehouseUpdate,
    });
  };

  public canDelete(item: WarehouseEntityVote): boolean {
    if (item.isDefault) {
      return false;
    }

    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationWarehouseDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextOperationWarehouseDelete,
    });
  }

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationWarehouseCreateany,
        PermissionAttributesEnum.GlobalOperationWarehouseUpdateany,
        PermissionAttributesEnum.GlobalOperationWarehouseDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationWarehouseCreate,
        PermissionAttributesEnum.ContextOperationWarehouseUpdate,
        PermissionAttributesEnum.ContextOperationWarehouseDelete,
      ],
    });
  };
}
